<template>
  <DesktopVersion
    class="mb-32 hidden md:block"
    :initial-values
    :page-type
    :status-filter-option
    @apply-filters="handleApplyFilters"
  />

  <MobileVersion
    class="md:hidden"
    :initial-values
    :page-type
    :status-filter-option
    @apply-filters="handleApplyFilters"
  />
</template>

<script setup lang="ts">
import type {
  Filter,
  FilterOptionItem,
} from '~/api/seller-after-sales/types/requests.types'

import DesktopVersion from './DesktopVersion/DesktopVersion.vue'
import MobileVersion from './MobileVersion/MobileVersion.vue'

defineProps<{
  pageType: string
  statusFilterOption: Array<FilterOptionItem>
  initialValues: Filter
}>()

const emit = defineEmits(['apply-filters'])

function handleApplyFilters(values: Filter) {
  emit('apply-filters', values)
}
</script>
